export default "__VITE_ASSET__B7HGHRt9__"